import './job.css';
import img_zeugnisse from '../../img/zeugnisse.png';

export default function Zeugnisse() {
  return (
    <div id="wrapper">
      <div className="section_title">Zeugnisse</div>
      <div
        style={{
          padding: '20px 20px',
          color: '#55ba5e',
          backgroundColor: '#ffffff',
          width: '90%',
          padding: '10px',
          margin: '10px',
          float: 'left'
        }}
      >
        <h2 className="angebote">
          Digitaler Zeugnisantrag - jetzt einfach online
        </h2>
        <span style={{ color: '#000000', fontSize: '14px' }}>
          <p>
            Sie benötigen für sich oder Ihre Mitarbeiterinnen und Mitarbeiter ein Arbeitszeugnis oder Zwischenzeugnis?
            <br/>
            Ab sofort stellen Sie Ihren Antrag ganz bequem digital über unsere Cloud.
            <br/>
            Der neue Prozess spart Zeit, ist transparent und ermöglicht eine zügige Bearbeitung durch die Personalabteilung.
          </p>

          <p>
            <b>So funktioniert´s:</b>
          </p>
          <p>
            Der digitale Antrag ersetzt vollständig den bisherigen E-Mail-Weg. Sie füllen das Online-Formular aus – alles Weitere läuft automatisch:
          </p>
          <p>
            Das Zeugnis wird erstellt, per Post versendet und Sie erhalten eine Bestätigung, sobald es auf dem Weg ist.
          </p>

          <p>
            <b>Wichtig:</b>
          </p>
          <ul style={{ listStyleType: '&ndash;&nbsp;'}}>
            <li>
              Nur vollständige Angaben ermöglichen eine zügige Bearbeitung.
            </li>
            <li>
              Sollte Ihnen im Nachhinein auffallen, dass eine Angabe fehlt oder fehlerhaft ist, wenden Sie sich bitte direkt an die Personalabteilung - <u>ein zweiter Antrag ist nicht erforderlich.</u>
            </li>
            <li>
              Für alle procuratio-Mitarbeitenden ist <a href="mailto:luca.erven@procuratio.com">Frau Erven</a> Ihre Ansprechperson, für alle anderen Firmen <a href="mailto:carolin.esposito@procuratio.com">Frau Esposito</a>.
            </li>
          </ul>

          <img
            className="zeugnisse"
            src={img_zeugnisse}
          />

          <br></br>
          <p style={{fontWeight: 'bold'}}>
            📄 Eine Schritt-für-Schritt-Anleitung finden Sie hier:
            <ul style={{ listStyleType: '&ndash;&nbsp;'}}>
              <li>
                <a
                  className="underline"
                  target="_blank"
                  href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/Kurzanleitung/Kurzanleitung_Zeugnisantrag.pdf"
                >
                  PDF
                </a>
              </li>
              <li>
                <a
                  className="underline"
                  target="_blank"
                  href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/Kurzanleitung/Kurzanleitung_Zeugnisantrag.mp4"
                >
                  Video
                </a>
              </li>
            </ul>
          </p>
          <br></br>

          <div style={{fontSize: '1.3em', fontWeight: 'bold'}}>
            <p>
              Jetzt Zeugnis beantragen:
            </p>
            <p>
              <a className="underline" target="_blank" href="https://files.procuratio.com:8441/index.php/apps/forms/Hi5WXeCfQGKGr6z9/submit">Zum Zeugnisantrag - Nextcloud Forms</a>
            </p>
          </div>
          <br></br>
          <br></br>
          <br></br>
          <br></br>

          <br></br>
          <br></br>

          <br></br>

        </span>
      </div>
    </div>
  );
}
